import { ref } from 'vue'

export const HideEsri = () => {
  const cssModified = ref(false)

  const mapEl = document.querySelector('arcgis-map') as HTMLElement
  if (cssModified.value === true) return
  const interval = setInterval(() => {
    const shadowRoot = mapEl.shadowRoot

    const el = mapEl.shadowRoot?.querySelector('.esri-attribution') as HTMLElement
    const viewEl = mapEl.shadowRoot?.querySelector('.esri-view') as HTMLElement
    if (shadowRoot && el && viewEl) {
      const adoptedStyleSheets = shadowRoot.adoptedStyleSheets
      const firstStyleSheet = adoptedStyleSheets[0] as CSSStyleSheet
      addRule(
        firstStyleSheet,
        `
                    .esri-attribution {
                        display: none !important;
                    }
                `,
      )
      addRule(
        firstStyleSheet,
        `
                    .esri-view {
                        --esri-view-outline: none !important;
                    }
                `,
      )
      addRule(
        firstStyleSheet,
        `
                    .esri-popup--is-docked {
                        z-index: 50 !important;
                        margin-top: calc(var(--spacing) * 20) !important;
                    }
                `,
      )
      addRule(
        firstStyleSheet,
        `
                    .esri-popup__main-container {
                        background-color: var(--ui-bg) !important;
                        border-color: var(--ui-border);
                        max-height: 40vh !important;
                        border-radius: var(--radius-lg);
                        border-style: var(--tw-border-style);
                        border-width: 1px;
                        border-bottom-style: var(--tw-border-style);
                        border-bottom-width: 0px;
                        --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
                        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
                        @media (width >= 48rem /* 768px */) {
                            max-height: 60vh;
                        }
                        @media (width >= 48rem /* 768px */) {
                            border-radius: calc(var(--ui-radius) * 3);
                        }
                    }
                `,
      )
      addRule(
        firstStyleSheet,
        `
                    .esri-widget__heading {
                        color: var(--ui-text-highlighted);
                    }
                `,
      )
      addRule(
        firstStyleSheet,
        `
                    .esri-widget__table {
                        color: var(--ui-text);
                    }
                `,
      )
      cssModified.value = true
      clearInterval(interval)
    }
  }, 500)
}

function addRule(sheet: CSSStyleSheet, rule: string) {
  sheet.insertRule(rule, sheet.cssRules.length)
}
